export default (function () {
  $('.hero').each(function () {
    var $headerHeight;
    $headerHeight = $('.hero-header').outerHeight();
    $(this).css('padding-top', $headerHeight + 'px');
    $(this).css('margin-top', '-' + $headerHeight + 'px');
  });

  if (window.matchMedia('(min-width: 769px)').matches) {
    $('.hero-3').each(function () {
      var $imageHeight, $headerHeight;
      $imageHeight = $(this).find('.hero-3__wrapper').outerHeight();
      $headerHeight = $('.hero-header').outerHeight();
      $(this).find('.hero-3__image img').css('height', $imageHeight + $headerHeight);
      $(this).find('.hero-3__image img').css('margin-top', '-' + $headerHeight + 'px');
    });
  }

  var $closeContainerWidth;
  var box = document.querySelector('.modal');
  var scrollbarWidth = box.offsetWidth - box.clientWidth;
  $closeContainerWidth = $(window).width();
  $('.close-wrapper').css('width', $closeContainerWidth - scrollbarWidth);
  var $headerHeight = $(".header.hero-header").outerHeight();
  $('.hero-0').css('margin-top', '-' + $headerHeight + 'px');
});